import axiosInstance from './axiosInstance';

// AFA tariff rates (General Settings). GET is open to any authenticated user
// (the RSC needs the current rate); SAVE is Super-Admin only (enforced server-side).
export const getAfaSettings = () => axiosInstance.get('/GeneralSettings/GetAfa');
export const saveAfaSettings = (data) => axiosInstance.post('/GeneralSettings/SaveAfa', data);

// Mark-up Commission share (MUC). GET also returns the agents carrying their own
// override, so the admin can see at a glance who is off the global number.
export const getMarkupShare = () => axiosInstance.get('/GeneralSettings/GetMarkupShare');
export const saveMarkupShare = (data) => axiosInstance.post('/GeneralSettings/SaveMarkupShare', data);

// AI / LLM settings (Super Admin) — keys are masked on read.
export const getAiSettings = () => axiosInstance.get('/GeneralSettings/GetAiSettings');
export const saveAiSettings = (data) => axiosInstance.post('/GeneralSettings/SaveAiSettings', data);
export const resetAiUsage = () => axiosInstance.post('/GeneralSettings/ResetAiUsage');
export const testAiSettings = () => axiosInstance.post('/GeneralSettings/TestAiSettings');

// Commission-slip period (duration) — effective-dated round config.
export const getSlipPeriodConfig = () => axiosInstance.get('/Slip/period-config').then(r => r.data);
export const saveSlipPeriodConfig = (body) => axiosInstance.post('/Slip/period-config', body).then(r => r.data);
